/**
 * Sticky
 * @author Rhys Lloyd
 */
//
// Utilities
import debug from "debug";
const MODULE_NAME = 'sticky';
const log = debug(MODULE_NAME);

//
// Dependencies
import defaults from 'lodash/defaults';
import uniqueId from 'lodash/uniqueId';

import '@vendor/fixed-sticky';

//
// Constants
const DEFAULTS = {
	zIndex: 700
};
const STICKY_SELECTOR = '[data-sticky]';

//
// Cache
let $stickyElements;

//
// Functions
function initStickyElement () {
	let $this = $(this);

	// Scroll options - custom for this element
	let customOptions = $this.data('options');

	if (!customOptions) {
		customOptions = {};
	}

	// Merge custom options with defaults
	defaults(customOptions, DEFAULTS);

	this.id = uniqueId('sticky_');
	$this.fixedsticky(customOptions);
}

//
// Exports
export function exec () {
	log('Running...');
	// Fetch links
	$stickyElements = $(STICKY_SELECTOR);

	// Bail if not needed
	if (!$stickyElements.length) {
		log('No sticky elements found');
	}

	log('$stickyElements:', $stickyElements);

	//
	// Bind Handlers
	setTimeout(() => {
		$stickyElements.each(initStickyElement);
	}, 0);

}

export {exec as default};




// WEBPACK FOOTER //
// ./project/client/src/core/modules/sticky/sticky.js